import {useEffect, useRef} from 'react';

/** A hook that captures the previous value of a variable. */
export function usePrevious<T>(state: T): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = state;
  }, [state]);

  return ref.current;
}
